import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { OFFER_ANCHOR, previewImages } from '../data/electrical';
export function PreviewCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(previewImages.length - 1, i));
    const slide = track.children[clamped] as HTMLElement | undefined;
    if (slide) {
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const width = track.clientWidth;
      if (width === 0) return;
      setIndex(Math.round(track.scrollLeft / width));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-navy px-4 py-4 sm:py-6" data-id="element-123" data-mp="3am5d243745ij">
      <div className="mx-auto max-w-3xl" data-id="element-124" data-mp="3amnedf4pt9xb">
        <p className="text-center font-head text-[10px] font-extrabold uppercase tracking-[0.2em] text-volt sm:text-xs" data-id="element-125" data-mp="3fl8hbmbcq7pg">
          PREVIEW THE MATERIAL
        </p>
        <h2 className="mt-0.5 text-center text-lg leading-tight text-white sm:text-3xl" data-id="element-126" data-mp="3kd9owuxkra95">
          Take a Look Inside ELECTRICAL DIAGNOSTIC PRO™
        </h2>
        <p className="mx-auto mt-1 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/85" data-id="element-127" data-mp="3tbu1rfggeppg">
          Explore the visual diagnostic maps, troubleshooting flows, circuit
          references, testing pathways, measurement examples and ready-to-use
          field resources included throughout the complete system.
        </p>

        <div className="relative mt-2" data-id="element-128" data-mp="23zji3gf2m7vt">
          <ul ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth" aria-label="Preview of pages inside ELECTRICAL DIAGNOSTIC PRO" data-id="element-129" data-mp="28wiek5m7iqx6">
            {previewImages.map(image => <li key={image.src} className="w-full shrink-0 snap-center" data-id="element-130" data-mp="1vzdkx1z9eukt">
                <a href={OFFER_ANCHOR} className="block" data-id="element-131" data-mp="2avl2rvn73jwx">
                  <img src={image.src} alt={image.alt} loading="lazy" className="mx-auto w-full rounded-lg border-2 border-volt bg-white shadow-2xl" data-id="element-132" data-mp="25uxcxdapd94a" />
                </a>
              </li>)}
          </ul>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-volt text-navy shadow-lg transition-colors duration-150 hover:bg-white disabled:pointer-events-none disabled:opacity-0" data-id="element-133" data-mp="2tjq12nl32coc">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-134" data-mp="3h8xziyg02ibp" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === previewImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-volt text-navy shadow-lg transition-colors duration-150 hover:bg-white disabled:pointer-events-none disabled:opacity-0" data-id="element-135" data-mp="3m5y392pdn8zn">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-136" data-mp="2pgyxbuc9mjam" />
          </button>
        </div>

        <div className="mt-1.5 flex items-center justify-center gap-2" data-id="element-137" data-mp="2tik736ti6hgl">
          {previewImages.map((image, i) => <button key={image.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1} of ${previewImages.length}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-soft ${i === index ? 'w-6 bg-volt' : 'w-2 bg-white/40 hover:bg-white/70'}`} data-id="element-138" data-mp="2fi9fg1kdcyud" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}